import { createClient } from "@supabase/supabase-js";
import { Database } from "./types";

// Supabase client initialization
export const supabase = createClient<Database>(
  "https://wfuvfnmjtnejnmhbdpqr.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndmdXZmbm1qdG5lam5taGJkcHFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyNjAzMDgsImV4cCI6MjA1OTgzNjMwOH0.hFquIHUGb8j2RgAsYru5jGYvpweOuCDDJfe0khOdXZQ"
);

export interface Sponsor {
  id: string;
  name: string;
  logo_url: string;
  website_url: string;
  tier: string;
  conference_id: string;
  created_at: string;
  updated_at: string;
}

export interface Speaker {
  id: string;
  name: string;
  slug: string; // Added slug property
  title: string;
  bio: string; // Added bio property
  image_url: string | null;
  company_name: string | null;
  company_logo: string | null;
  topic: string | null;
  twitter_url: string | null;
  linkedin_url: string | null;
  github_url: string | null;
  conference_id: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface ScheduleItem {
  id: string;
  day: string; 
  start_time: string;
  end_time: string;
  title: string;
  description: string | null;
  location: string | null;
  type: string | null;
  speaker_id?: string | null;
  speaker?: { name: string } | null;
  conference_id?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface Conference {
  id: string;
  name: string;
  slug: string;
  description: string;
  start_date: string;
  end_date: string;
  location: string;
  website_url: string;
  logo_url: string;
  created_at: string;
  updated_at: string;
}
